import { useEffect, useRef } from 'react'

export const useOutsideClick = (callback: () => void) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (
        ref.current &&
        !ref.current.contains(event.target as Node | null) &&
        !document.querySelector('.ant-drawer')?.contains(event.target as Node | null) &&
        !document.querySelector('.ant-picker-dropdown')?.contains(event.target as Node | null) &&
        !document.querySelector('.ant-picker-panel')?.contains(event.target as Node | null)
      ) {
        callback()
      }
    }

    document.addEventListener('mousedown', handleClick)

    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  })

  return ref
}
